// variant of https://github.com/VividSeats/vivid-ui-kit/blob/main/src/components/production-listing-row/component.tsx

import React, { forwardRef, HTMLAttributes } from 'react'

import { Column, Grid, Row, Text } from '@vividseats/vivid-ui-kit'
import { ColProps } from '@vividseats/vivid-ui-kit/dist/components/column'
import classnames from 'classnames'

import HomeOpenerBadge from '../home-opener-badge'
import LowPricesDealsAvailableBadge from '../scarcity-badging/low-prices-deals-available-badge'
import SellingFastBadge from '../scarcity-badging/selling-fast-badge'

import styles from './styles.module.scss'

interface VariantProductionListingRowWithBadgingType extends HTMLAttributes<HTMLAnchorElement> {
    date?: string
    day?: string
    time?: string
    title: string
    label: string
    sublabel?: string
    mobileDivider?: boolean
    href?: string
    altFont?: boolean
    titleColumnProps?: ColProps
    classes?: { date?: string; label?: string; row?: string; title?: string; titleWrapper?: string }
    isSellingFast?: boolean
    isLowPricesDealsAvailable?: boolean
    isHomeOpener?: boolean
}

const VariantProductionListingRowWithBadging: React.ForwardRefRenderFunction<
    React.MutableRefObject<unknown>,
    VariantProductionListingRowWithBadgingType
> = (
    {
        label,
        sublabel,
        title,
        date,
        day,
        time,
        mobileDivider = true,
        href,
        className,
        children,
        altFont,
        titleColumnProps = { ml: 1.5 },
        classes = {},
        isSellingFast,
        isLowPricesDealsAvailable,
        isHomeOpener,
        ...props
    },
    ref: any,
) => {
    const classNames = classnames(classes.row || styles.row, className)

    return (
        <>
            <a {...props} ref={ref} className={styles.link} href={href}>
                <Row justify="left" align="stretch" className={classNames}>
                    <div className={styles.leftRail}>
                        <Text
                            altFont={altFont}
                            size="md"
                            weight="semi-bold"
                            className={classnames(classes.date, {
                                [styles.paddingTop]: isSellingFast || isLowPricesDealsAvailable || isHomeOpener,
                            })}
                        >
                            {date}
                        </Text>
                        <Column mt={0.125}>
                            <Text altFont={altFont} size="sm">
                                {day} • {time}
                            </Text>
                        </Column>
                    </div>
                    <Column {...titleColumnProps} className={classes.titleWrapper}>
                        {isSellingFast ? (
                            <SellingFastBadge />
                        ) : isLowPricesDealsAvailable ? (
                            <LowPricesDealsAvailableBadge />
                        ) : isHomeOpener ? (
                            <HomeOpenerBadge />
                        ) : null}
                        <Text altFont={altFont} size="md" weight="semi-bold" className={classes.title}>
                            {title}
                        </Text>
                        <Column mb={0.0625}>
                            <Text altFont={altFont} size="sm" className={classes.label}>
                                {label}
                            </Text>
                        </Column>
                        {!!sublabel && (
                            <Text altFont={altFont} size="sm" opaque>
                                {sublabel}
                            </Text>
                        )}
                    </Column>
                    {children}
                </Row>
            </a>

            {mobileDivider && (
                <Grid desktop={false} tablet={false}>
                    <hr />
                </Grid>
            )}
        </>
    )
}

export default forwardRef(VariantProductionListingRowWithBadging)
